<template>
	<div>
		<add-integration :id="id" />
		<div>
			<router-view :key="$route.fullPath" />
		</div>
	</div>
</template>

<script>
import AddIntegration from './components/add-integration'

export default {
	components: {
		AddIntegration,
	},

	props: {
		id: {
			type: [Number,String],
			required: false,
			default: 0,
		},
	}
}
</script>